/**
 * Hardcoded warehouse destination printers. The WMS owns the destination IP
 * and sends it to the print relay; the relay does not pick the printer.
 */

export const DESTINATION_PRINTERS = [
  { id: 'shipping_computer', label: 'Shipping Computer', ip: '192.168.1.26' },
  { id: 'wifi_printer', label: 'WIFI Printer', ip: '192.168.1.247' },
] as const;

export type DestinationPrinterId = (typeof DESTINATION_PRINTERS)[number]['id'];

export const DESTINATION_PRINTER_IDS = [
  DESTINATION_PRINTERS[0].id,
  DESTINATION_PRINTERS[1].id,
] as const;

export const DEFAULT_PRINTER_ID: DestinationPrinterId = 'shipping_computer';

export function isDestinationPrinterId(value: string): value is DestinationPrinterId {
  return DESTINATION_PRINTERS.some((entry) => entry.id === value);
}

export function getPrinterIp(printerId: DestinationPrinterId): string {
  const printer = DESTINATION_PRINTERS.find((entry) => entry.id === printerId);
  if (!printer) {
    throw new Error(`Unknown destination printer: ${printerId}`);
  }
  return printer.ip;
}

/** One host-query result from the print-relay status probe. Never a print. */
export interface PrinterProbeQueryResult {
  readonly command: string;
  readonly what: string;
  readonly answered: boolean;
  readonly hex: string;
  readonly ascii: string;
}

/** Operator-only tag for a Dev Panel probe run. Not sent to the printer. */
export const PRINTER_PROBE_PHYSICAL_STATES = ['ready', 'lid_open', 'paper_out'] as const;
export type PrinterProbePhysicalState = (typeof PRINTER_PROBE_PHYSICAL_STATES)[number];

export const PRINTER_PROBE_PHYSICAL_STATE_LABELS: Readonly<Record<PrinterProbePhysicalState, string>> = {
  ready: 'Ready',
  lid_open: 'Lid open',
  paper_out: 'Paper out',
};
